export function setMenuList(data) {
  return {
    type: 'SET_MENU',
    data
  };
}

export function setSelectedMenu(data) {
  return {
    type: 'SET_SELECTED_MENU',
    data
  };
}